import { AssetSvg as e } from "../assets/AssetSvg.js";
import { flagRegistry as t } from "./registry.js";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/flags/CountryFlag.tsx
var r = ({ code: r, size: i = 16, label: a, className: o, ...s }) => {
	let c = r.trim().toUpperCase(), l = Object.hasOwn(t, c) ? t[c] : void 0;
	return l ? /* @__PURE__ */ n(l, {
		size: i,
		label: a,
		className: o,
		...s
	}) : /* @__PURE__ */ n(e, {
		width: i,
		height: i,
		viewBox: "0 0 24 24",
		label: a,
		className: ["pf-flag-unknown pf:rounded-full pf:bg-soft-pearl-200 pf:shadow-[inset_0_0_0_0.5px_var(--pf-color-soft-pearl-300)]", o].filter(Boolean).join(" "),
		...s
	});
};
//#endregion
export { r as CountryFlag };
